import { render, staticRenderFns } from "./SeriesTable.vue?vue&type=template&id=a24efe3c"
import script from "./SeriesTable.vue?vue&type=script&lang=js"
export * from "./SeriesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports